 


import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import TopBar from "../components/TopBar";
import SideMenu from "../components/SideMenu";
import usePWAInstall from "../PWA/usePWAInstall";

export default function POSLayout() {
  const { installApp, canInstall, isInstalled } = usePWAInstall();

  // State to track if we already asked for notification permission
  const [askedNotification, setAskedNotification] = useState(false);

  useEffect(() => {
    // Only run after PWA is installed
    if (isInstalled && !askedNotification) {
      // Check if browser supports notifications
      if ("Notification" in window) {
        Notification.requestPermission().then((permission) => {
          console.log("Notification permission:", permission);

          if (permission === "granted") {
            // You can now send notifications from your service worker
            console.log("Notifications are allowed ✅");
          } else if (permission === "denied") {
            console.log("Notifications are blocked ❌");
          } else {
            console.log("Notifications permission dismissed ⚪");
          }
        });
      }
      setAskedNotification(true); // mark that we asked already
    }
  }, [isInstalled, askedNotification]);

  return (
    <div className="h-screen flex bg-gray-100">
      {/* DESKTOP SIDEMENU */}
      <aside className="hidden md:block w-64 bg-white border-r fixed h-full">
        <SideMenu />
      </aside>

      {/* MAIN CONTENT */}
      <div className="flex-1 flex flex-col md:ml-64">
        <TopBar />

        {/* ✅ Native Style Install Banner */}
        {canInstall && (
          <div className="bg-white shadow-md m-2 p-3 rounded-lg flex items-center justify-between">
            <div>
              <p className="font-semibold">Install HemAunty POS</p>
              <p className="text-sm text-gray-500">
                Faster & full-screen experience
              </p>
            </div>
            <button
              onClick={installApp}
              className="bg-blue-600 text-white px-4 py-2 rounded"
            >
              Install
            </button>
          </div>
        )}

        {/* MAIN APP CONTENT */}
        <main className="flex-1 overflow-y-auto hide-scrollbar">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
